import script from "./AccommodationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccommodationComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccommodationComponent.vue?vue&type=style&index=0&id=7da6a257&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da6a257"]])

export default __exports__